import { useMemo } from 'react';

import { useNominalLebihBayarEnabled } from './useNominalLebihBayarEnabled';
import { useShiptoDepositBalance } from './useShiptoDepositBalance';

export function useNlbRedDotIndicator() {
  const isNlbEnabled = useNominalLebihBayarEnabled();
  const { data, isError, isLoading } = useShiptoDepositBalance();

  const showRedDot = useMemo(() => {
    if (!isNlbEnabled || isError || isLoading) {
      return false;
    }

    return (data?.available_balance ?? 0) > 0;
  }, [data?.available_balance, isError, isLoading, isNlbEnabled]);

  return {
    showRedDot,
    isNlbEnabled,
  };
}
